<template>
  <q-dialog v-model="showModal" @hide="onHide" :max-width="maxWidth">
    <q-card class="modal-detail-template" style="height: 90vh; max-height: 90vh;">
      <q-linear-progress :value="1" class="bg-primary" />
      <q-toolbar class="bg-primary text-white">
        <q-toolbar-title class="text-h6">
          <translate>VIEW_TEMPLATE</translate>
        </q-toolbar-title>
        <q-btn v-close-popup flat round dense icon="close" />
      </q-toolbar>

      <q-card-section class="detail-content q-pa-md">
        <div class="row q-col-gutter-md">
          <div class="col-12 col-md-6 detail-col-left">
            <q-card flat class="q-mb-lg">
              <q-card-section class="q-py-sm q-card__section q-card__section--vert">
                <div class="crud-title row items-center justify-between">
                  <span>{{ this.$gettext('TEMPLATE_INFORMATION') }}</span>
                  <div class="row items-center q-gutter-xs">
                  <span class="status-dot" :class="formData.available ? 'status-dot--active' : 'status-dot--inactive'"></span>
                    <span class="text-caption text-weight-bold">
                      {{ formData.available ? this.$gettext('ACTIVE') : this.$gettext('INACTIVE') }}
                    </span>
                  </div>
                </div>
              </q-card-section>
              <q-card-section>
                <div class="info-row q-mb-md">
                  <div class="info-label">{{ this.$gettext('NAME') }}</div>
                  <div class="info-value text-weight-bold">{{ formData.name }}</div>
                </div>

                <div class="row q-col-gutter-md q-mb-md">
                  <div class="col-6">
                    <div class="info-row">
                      <div class="info-label">{{ this.$gettext('TEMPLATE_PURPOSE') }}</div>
                      <div class="info-value row items-center q-gutter-sm">
                        <q-icon :name="getPurposeIcon(formData.messagingPurpose)" size="16px" color="blue" />
                        <span>{{ formData.messagingPurpose_nmDescricao }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="info-row">
                      <div class="info-label">{{ this.$gettext('SEND_CHANNEL') }}</div>
                      <div class="info-value row items-center q-gutter-sm">
                        <q-icon :name="getChannelIcon(formData.channelType)" size="16px" :style="{ color: getChannelColor(formData.channelType) + ' !important' }" />
                        <span>{{ formData.channelType_nmDescricao }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row q-col-gutter-md q-mb-md">
                  <div class="col-6">
                    <div class="info-row">
                      <div class="info-label">{{ this.$gettext('CREATED_AT') }}</div>
                      <div class="row items-center q-gutter-sm">
                        <q-icon name="event" size="16px" color="#666"/>
                        <span class="info-value">{{ formatAuditDateTime(formData.createdAt) }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="info-row">
                      <div class="info-label">{{ this.$gettext('UPDATED_AT') }}</div>
                      <div class="row items-center q-gutter-sm">
                        <q-icon name="event" size="16px" color="#666"/>
                        <span class="info-value">{{ formatAuditDateTime(formData.updatedAt) }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="info-row">
                  <div class="info-label">{{ this.$gettext('RESPONSIBLE') }}</div>
                  <div class="row items-center q-gutter-sm">
                    <q-icon name="person" size="16px" color="#666"/>
                    <span class="info-value text-caption">{{ formData.responsible_nmLogin }}</span>
                  </div>
                </div>
              </q-card-section>
            </q-card>

            <q-card v-if="campaignRows.length > 0" flat class="card-template">
              <q-card-section class="q-py-sm q-card__section q-card__section--vert">
                <div class="crud-title row items-center justify-between">
                  <span>{{ this.$gettext('LINKED_CAMPAIGNS') }}</span>
                  <q-chip color="blue-2" text-color="blue" dense>{{ campaignRows.length }}</q-chip>
                </div>
              </q-card-section>
              <q-card-section>
                <q-table
                  :rows="campaignRows"
                  :data="campaignRows"
                  :columns="campaignColumns"
                  row-key="id"
                  flat
                  dense
                  :pagination.sync="campaignPagination"
                  hide-bottom
                >
                  <template v-slot:body-cell-status="props">
                    <q-td :props="props">
                      <div class="row items-center q-gutter-xs">
                        <span class="campaign-status-dot" :style="{ backgroundColor: getCampaignStatusColor(props.row.statusCode) }"></span>
                        <span class="text-caption">{{ props.row.status }}</span>
                      </div>
                    </q-td>
                  </template>
                </q-table>
              </q-card-section>
            </q-card>
          </div>

          <div class="col-12 col-md-6 detail-col-right">
            <template-preview-panel
              :title="this.$gettext('MESSAGE_PREVIEW')"
              :purpose-label="formData.messagingPurpose_nmDescricao"
              :channel-label="formData.channelType_nmDescricao"
              :channel-icon="getChannelIcon(formData.channelType)"
              :channel-color="getChannelColor(formData.channelType)"
              :channel-type="formData.channelType"
              :channel-types="channelTypes"
              :subject="formData.subject"
              :body-html="formData.content"
              :message-variables="messageVariables"
              :header-image="headerImagePreview"
              :footer-image="footerImagePreview"
              :is-read-only="true"
              :show-controls="false"
            />
          </div>
        </div>
      </q-card-section>

      <q-card-section class="detail-footer q-pa-md row justify-center q-gutter-x-md">
        <q-btn
          :label="this.$gettext('CLOSE')"
          color="primary"
          @click="onClose"
          class="q-px-xl"
        />
        <q-btn
          :label="this.$gettext('EDIT')"
          color="green"
          @click="onEdit"
          class="q-px-xl"
        />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { messageBox, repository } from 'jtech'
import { date } from 'quasar'
import { formatDateTimeLocal } from 'src/shared/utils/dateUtils.js'
import TemplatePreviewPanel from './TemplatePreviewPanel.vue'
import { templateImageType } from 'src/shared/inf-tabela-descricao/TemplateImageType.enum.js'
import { messagingPurpose } from 'src/shared/inf-tabela-descricao/MessagingPurpose.enum.js'
import { campaignStatus } from 'src/shared/inf-tabela-descricao/CampaignStatus.enum.js'
import { variableType } from 'src/shared/inf-tabela-descricao/VariableType.enum.js'
import { getChannelColor, getChannelIcon } from '../utils/channelMappings.js'

@Component({
  name: 'TemplateDetailModal',
  components: {
    TemplatePreviewPanel
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    getPurposeIcon: {
      type: Function,
      required: true
    },
    purposeTypes: {
      type: Object,
      required: true
    }
  }
})
class TemplateDetailModal extends Vue {
  get HEADER_IMAGE_TYPE () {
    return templateImageType().HEADER.key
  }

  get FOOTER_IMAGE_TYPE () {
    return templateImageType().FOOTER.key
  }

  getChannelIcon (channelId) {
    return getChannelIcon(channelId)
  }

  getChannelColor (channelId) {
    return getChannelColor(channelId)
  }

  showModal = false
  currentId = null
  maxWidth = '1800px'

  formData = {
    name: '',
    messagingPurpose: null,
    messagingPurpose_nmDescricao: '',
    channelType: null,
    channelType_nmDescricao: '',
    subject: '',
    content: '',
    available: true,
    createdAt: null,
    updatedAt: null,
    responsible_nmLogin: ''
  }

  campaigns = []
  campaignColumns = [
    {
      name: 'name',
      label: this.$gettext('CAMPAIGN'),
      field: 'name',
      align: 'left'
    },
    {
      name: 'status',
      label: this.$gettext('STATUS'),
      field: 'status',
      align: 'left'
    },
    {
      name: 'startDate',
      label: this.$gettext('START_DATE'),
      field: 'startDate',
      align: 'left'
    }
  ]

  campaignPagination = {
    rowsPerPage: 5
  }

  purposeOptions = []
  channelOptions = []
  messageVariables = []

  headerImagePreview = null
  footerImagePreview = null

  mounted () {
    this.showModal = this.show
  }

  get campaignRows () {
    const items = Array.isArray(this.campaigns) ? this.campaigns : []
    return items.map((item, index) => {
      return {
        id: item.id || index,
        name: item.name || '',
        status: item.status_nmDescricao || '',
        statusCode: item.status,
        startDate: item.startDate || ''
      }
    })
  }

  get hasImages () {
    return !!this.headerImagePreview || !!this.footerImagePreview
  }

  get purposeDescription () {
    const purposeId = this.formData.messagingPurpose
    const p = messagingPurpose()
    const descriptions = {
      [p.ONE_TIME_PAYMENT.key]: this.$gettext('PURPOSE_ONE_TIME_PAYMENT'),
      [p.INSTALLMENT.key]: this.$gettext('PURPOSE_PAYMENT_INSTALLMENT'),
      [p.REGULAR_INVOICE.key]: this.$gettext('PURPOSE_REGULAR_INVOICE'),
      [p.NOTICE.key]: this.$gettext('PURPOSE_NOTICE'),
      [p.ADDITIONAL.key]: this.$gettext('PURPOSE_ADDITIONAL')
    }
    return descriptions[purposeId] || ''
  }

  getCampaignStatusColor (statusCode) {
    const statuses = campaignStatus()
    if (String(statusCode) === String(statuses.ENDED.key)) {
      return 'rgb(0, 98, 169)' // blue
    }
    if (String(statusCode) === String(statuses.ACTIVE.key)) {
      return 'rgb(0, 97, 59)' // green
    }
    if (String(statusCode) === String(statuses.PAUSED.key)) {
      return 'rgb(209, 142, 75)' // yellow/orange
    }
    if (String(statusCode) === String(statuses.DRAFT.key)) {
      return 'rgb(112, 112, 112)' // gray
    }

    return 'rgb(112, 112, 112)' // default gray
  }

  formatAuditDateTime (dateValue) {
    return formatDateTimeLocal(dateValue)
  }

  async openDetail (id) {
    this.currentId = id
    await this.loadRecord(id, 'detalhar')
    this.showModal = true
    this.$emit('update:show', true)
  }

  async loadRecord (id, action) {
    try {
      const [response, variablesForm] = await Promise.all([
        repository.resolve(`template.${action}`, { id }),
        repository.resolveLogic('msgVariableEnum.obterTodos')
      ])
      this.messageVariables = this.normalizeVariables(variablesForm)

      const dadosForm = response?.dadosForm || response?.[0]?.dadosForm || response?.[0] || {}

      await this.applyFormData(dadosForm)
    } catch (error) {
      console.error('Erro ao carregar template:', error)
      messageBox.error(this.$gettext('ERROR_LOADING_FORM'))
      this.messageVariables = []
    }
  }

  normalizeVariables (data) {
    const records = this.extractRecords(data)
    const result = records
      .map(category => ({
        variableType: category.variableType,
        nmDescricao: category.nmDescricao,
        variables: Array.isArray(category.variables)
          ? category.variables.map(variable => ({
            technicalKey: variable.technicalKey,
            displayLabel: variable.displayLabel,
            displayTag: variable.displayTag,
            variableType: variable.variableType,
            sampleText: variable.sampleText
          }))
          : []
      }))
      .filter(category => category.variables.length > 0)

    const varType = variableType()
    const getCategoryOrder = (typeId) => {
      if (typeId === varType.FINANCE.key) return 1
      if (String(typeId).startsWith('5047')) return 2
      if (typeId === varType.CONSUMER_UNIT_DATA.key) return 3
      if (typeId === varType.ORGANIZATION.key) return 4
      if (typeId === varType.CONTROL.key) return 5
      return 99
    }

    result.sort((a, b) => getCategoryOrder(a.variableType) - getCategoryOrder(b.variableType))
    return result
  }

  extractRecords (data) {
    if (!data) {
      return []
    }
    if (Array.isArray(data)) {
      if (data[0] && data[0].registros) {
        return data[0].registros
      }
      return data
    }
    if (data.registros) {
      return data.registros
    }
    return []
  }

  async applyFormData (form) {
    this.formData.name = form.name || ''
    this.formData.messagingPurpose = this.getIdValue(form.messagingPurpose)
    this.formData.messagingPurpose_nmDescricao = form.messagingPurpose_nmDescricao || ''
    this.formData.channelType = this.getIdValue(form.channelType)
    this.formData.channelType_nmDescricao = form.channelType_nmDescricao || ''
    this.formData.subject = form.subject || ''
    this.formData.content = form.content || ''
    this.formData.available = form.available !== undefined ? form.available : true
    this.formData.createdAt = form.createdAt || null
    this.formData.updatedAt = form.updatedAt || null
    this.formData.responsible_nmLogin = form.responsible_nmLogin || ''

    if (form.campaigns && Array.isArray(form.campaigns)) {
      this.campaigns = form.campaigns
    }

    if (form.templateImages && Array.isArray(form.templateImages)) {
      await this.loadExistingImages(form.templateImages)
    }
  }

  async loadExistingImages (images) {
    try {
      this.headerImagePreview = null
      this.footerImagePreview = null

      for (const img of images) {
        if (!img.nmArquivo || !img.templateImageType) {
          continue
        }

        const imageTypeId = img.templateImageType
        const isHeader = imageTypeId === this.HEADER_IMAGE_TYPE
        const isFooter = imageTypeId === this.FOOTER_IMAGE_TYPE

        if (isHeader || isFooter) {
          try {
            const blob = await this.$jt.repository.downloadFile(
              img.nmArquivo,
              null,
              'MESSAGING_TEMPLATE_IMAGES'
            )
            const blobUrl = URL.createObjectURL(blob)

            if (isHeader) {
              this.headerImagePreview = blobUrl
            } else if (isFooter) {
              this.footerImagePreview = blobUrl
            }
          } catch (error) {
            console.warn(`Erro ao baixar imagem ${img.nmArquivo}:`, error)
          }
        }
      }
    } catch (error) {
      console.error('Erro ao carregar imagens existentes:', error)
    }
  }

  getIdValue (value) {
    if (value && typeof value === 'object') {
      return value.id || value.chCodigo || value.value || null
    }
    return value || null
  }

  onClose () {
    this.showModal = false
    this.resetForm()
  }

  onEdit () {
    if (this.currentId) {
      this.$emit('edit-template', this.currentId)
      this.onClose()
    }
  }

  resetForm () {
    this.formData = {
      name: '',
      messagingPurpose: null,
      channelType: null,
      subject: '',
      content: '',
      available: true,
      dtCreate: null,
      dtUpdate: null,
      responsavel: ''
    }

    this.currentId = null
    this.headerImagePreview = null
    this.footerImagePreview = null
    this.campaigns = []
    this.messageVariables = []
  }

  onHide () {
    this.$emit('update:show', false)
    this.resetForm()
  }

  @Watch('show')
  onShowChange (newVal) {
    this.showModal = newVal
  }

  @Watch('showModal')
  onShowModalChange (newVal) {
    if (!newVal) {
      this.$emit('update:show', false)
    }
  }
}

export default TemplateDetailModal
</script>

<style lang="stylus" scoped>
.modal-detail-template
  min-width: 600px
  max-width: 85vw
  width: 85vw
  display: flex
  flex-direction: column

.detail-content
  overflow: hidden
  flex: 1
  padding: 16px !important

.detail-col-left
  height: calc(90vh - 70px)
  overflow-y: auto
  overflow-x: hidden
  padding-right: 8px

.detail-col-right
  height: calc(90vh - 70px)
  overflow-y: auto
  overflow-x: hidden

  &::v-deep .q-card,
  &::v-deep .q-card__section,
  &::v-deep .q-card-section
    overflow: visible !important

.card-template
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05)

.info-row
  display: flex
  flex-direction: column
  gap: 4px

.info-label
  font-size: 11px
  font-weight: 600
  color: #666
  text-transform: uppercase
  letter-spacing: 0.5px
  display: flex
  align-items: center

.info-value
  font-size: 14px
  line-height: 1.4

.status-dot
  width: 12px
  height: 12px
  border-radius: 50%
  display: inline-block

.status-dot--active
  background-color: #00613b

.status-dot--inactive
  background-color: #ee0000

.campaign-status-dot
  width: 12px
  height: 12px
  border-radius: 50%
  display: inline-block

.email-container
  min-height: 400px
  border: 1px solid #ccc
  max-height: calc(100vh - 400px)
  overflow-y: auto

.subject-box-preview
  border-bottom: 2px solid #e0e0e0

.body-box-preview
  min-height: 200px

.email-body-content
  line-height: 1.6
  color: #333
  word-wrap: break-word

  h1, h2, h3, h4, h5, h6
    margin: 16px 0 8px
    color: #222
    font-weight: 600

  p
    margin: 0 0 12px

  a
    color: #0056b3
    text-decoration: none

  strong
    font-weight: 600
    color: #222

  img
    max-width: 100%
    height: auto

.chip-context
  font-weight: 500

.preview-section
  background-color: #fff
  border-radius: 4px
  padding: 16px

.border-grey-light
  border: 1px solid #e0e0e0 !important

.detail-footer
  background-color: #ffffff
  border-top: 1px solid rgba(0, 0, 0, 0.12)
</style>
